const IndentedText = ({rec, fld, indentAttr}) => {
    return (
        <span style={{paddingLeft: `${rec[indentAttr] * 20}px`}}>
            {rec[fld.name]}
        </span>
    )
}

export default IndentedText